'use client'

import {
  buildTraxionEventsSearchHref,
  getGameDisplayLabel,
  getPlatformDisplayLabel,
  TRAXION_ANY_PLATFORM,
} from '@/lib/embed/traxion-search-prefill'
import { cn } from '@/lib/utils'
import Image from 'next/image'
import { useId, useMemo, useState } from 'react'

function TraxionGridFinderLogo(props) {
  const id = useId()
  const clipPathId = `clip0_traxion_gridfinder_logo_${id}`
  const gradient0Id = `paint0_linear_traxion_gridfinder_logo_${id}`
  const gradient1Id = `paint1_linear_traxion_gridfinder_logo_${id}`
  const gradient2Id = `paint2_linear_traxion_gridfinder_logo_${id}`
  const gradient3Id = `paint3_linear_traxion_gridfinder_logo_${id}`

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="128"
      height="32"
      viewBox="0 0 128 32"
      fill="none"
      {...props}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M0 0L23.5408 6.30635L47.0817 0V25.4352L23.5408 31.7416L0 25.4352V0Z"
          fill="#010810"
        />
        <path
          d="M9.28711 11.7614V18.6416L18.1357 21.0111V20.03L10.2682 17.9258V13.0079L23.0537 16.4326V27.2434L4.36914 22.2391V5.53528L23.0537 10.5396V15.4514L9.28711 11.7614Z"
          fill="white"
        />
        <path
          d="M28.9521 14.1354V15.1165L42.7188 11.4265V16.3445L28.9521 20.0345V25.9336L24.0342 27.2541V10.5441L42.7188 5.53973V10.4515L28.9521 14.1354Z"
          fill="white"
        />
        <path
          d="M0.986328 24.7156L8.07018 26.6161V24.2157L3.38052 22.9631V4.28471L8.07018 5.54352V3.14932L0.986328 1.24878V24.7156Z"
          fill={`url(#${gradient0Id})`}
        />
        <path
          d="M9.0498 24.4792V26.8734L23.5384 30.7547L37.9899 26.8858V24.4916L23.5384 28.3606L9.0498 24.4792Z"
          fill={`url(#${gradient1Id})`}
        />
        <path
          d="M9.0498 3.40979V5.81015L23.5384 9.68529V9.69146L37.9899 5.81632V3.42213L23.5384 7.2911L9.0498 3.40979Z"
          fill={`url(#${gradient2Id})`}
        />
        <path
          d="M38.9717 3.15549V5.55586L43.6984 4.28471V22.9631L38.9717 24.2281V26.6223L46.0925 24.7156V1.24878L38.9717 3.15549Z"
          fill={`url(#${gradient3Id})`}
        />
        <path
          d="M48.9316 0V11.792H63.087V4.16515H53.4053V7.63303H59.3661V8.33031H52.6587V3.47405H63.087V0H48.9316Z"
          fill="white"
        />
        <path
          d="M95.0209 0H83.2227V11.792H95.0209L97.378 9.43485V2.35717L95.0209 0ZM93.651 7.14555L92.4724 8.32414H86.9497V3.46788H92.4724L93.651 4.64646V7.15172V7.14555Z"
          fill="white"
        />
        <path d="M82.5317 0H78.8047V11.792H82.5317V0Z" fill="white" />
        <path
          d="M78.7046 13.6434V20.5236L71.8244 13.6434H68.1035V25.4354H71.8306V18.5552L78.7046 25.423V25.4354H82.4316V13.6434H78.7046Z"
          fill="white"
        />
        <path
          d="M97.876 13.6434V25.4354H112.031V21.9675H101.603V21.2764H112.031V17.8085H101.603V17.1174H112.031V13.6495H97.876V13.6434Z"
          fill="white"
        />
        <path
          d="M86.7531 17.1113H92.282L93.4605 18.2899V20.789L92.282 21.9676H86.7531V17.1113ZM83.0322 13.6434V25.4354H94.8304L97.1876 23.0783V16.0006L94.8304 13.6434H83.0322Z"
          fill="white"
        />
        <path
          d="M48.9316 13.6434V25.4354H52.6587V21.2703H63.0932V17.8024H52.6587V17.1113H63.0932V13.6434H48.9378H48.9316Z"
          fill="white"
        />
        <path
          d="M67.5112 13.6434H63.7842V25.4354H67.5112V13.6434Z"
          fill="white"
        />
        <path
          d="M116.456 17.1095H123.163V17.8068H116.456V17.1095ZM112.729 13.6478V25.4275H116.456V21.2994H120.639L123.33 24.1132V25.4337H127.057V23.1382L125.193 21.1574L127.057 19.5901V16.2642L124.403 13.6602H112.729V13.6478Z"
          fill="white"
        />
        <path
          d="M67.5051 3.46616H74.2125V4.16344H67.5051V3.46616ZM63.7842 0.00445557V11.7841H67.5112V7.656H71.6949L74.3853 10.4698V11.7903H78.1123V9.49484L76.2488 7.51408L78.1123 5.94674V2.62079L75.459 0.00445557H63.7842Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id={gradient0Id}
          x1="4.52825"
          y1="1.24878"
          x2="4.52825"
          y2="26.6161"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6100" />
          <stop offset="0.495407" stopColor="#FF4F00" />
          <stop offset="1" stopColor="#FF3D00" />
        </linearGradient>
        <linearGradient
          id={gradient1Id}
          x1="23.5199"
          y1="24.4792"
          x2="23.5199"
          y2="30.7547"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6100" />
          <stop offset="0.495407" stopColor="#FF4F00" />
          <stop offset="1" stopColor="#FF3D00" />
        </linearGradient>
        <linearGradient
          id={gradient2Id}
          x1="23.5199"
          y1="3.40979"
          x2="23.5199"
          y2="9.69146"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6100" />
          <stop offset="0.495407" stopColor="#FF4F00" />
          <stop offset="1" stopColor="#FF3D00" />
        </linearGradient>
        <linearGradient
          id={gradient3Id}
          x1="42.5321"
          y1="1.24878"
          x2="42.5321"
          y2="26.6223"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6100" />
          <stop offset="0.495407" stopColor="#FF4F00" />
          <stop offset="1" stopColor="#FF3D00" />
        </linearGradient>
        <clipPath id={clipPathId}>
          <rect width="127.059" height="31.7416" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

function TraxionSearchIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M7.51142 14.3682C11.2985 14.3682 14.3685 11.2981 14.3685 7.51105C14.3685 3.72397 11.2985 0.653931 7.51142 0.653931C3.72433 0.653931 0.654297 3.72397 0.654297 7.51105C0.654297 11.2981 3.72433 14.3682 7.51142 14.3682Z"
        stroke="white"
        strokeWidth="1.3079"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6552 16.654L12.3604 12.3591"
        stroke="white"
        strokeWidth="1.3079"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function TraxionChevronDownIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="7"
      viewBox="0 0 11 7"
      fill="none"
      {...props}
    >
      <path
        d="M1 1.25L5.5 5.75L10 1.25"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function TraxionSelect({
  label,
  value,
  onValueChange,
  options,
  getOptionLabel,
  className,
  selectClassName,
}) {
  return (
    <label
      className={cn(
        'relative block h-[64.941px] w-[163.765px] overflow-hidden rounded-[2.616px] border border-neutral-blue-700 bg-neutral-blue-900',
        className,
      )}
    >
      <span
        className="z-1 pointer-events-none absolute left-[18px] top-[14px] text-[11px] font-semibold uppercase tracking-[0.3em] text-[#627c9a]"
        style={{ fontFamily: 'var(--font-inter), sans-serif' }}
      >
        {label}
      </span>
      <select
        aria-label={label}
        value={value ?? ''}
        onChange={(event) => onValueChange(event.target.value)}
        className={cn(
          'outline-hidden h-full w-full appearance-none bg-neutral-blue-900 pb-[12px] pl-[18px] pr-[42px] pt-[31px] text-[16px] font-medium text-white transition-colors hover:bg-[#07101a] focus:bg-[#07101a]',
          selectClassName,
        )}
        style={{
          fontFamily: 'var(--font-inter), sans-serif',
          colorScheme: 'dark',
        }}
      >
        {options.map((option) => (
          <option key={option.name} value={option.name}>
            {getOptionLabel(option)}
          </option>
        ))}
      </select>
      <TraxionChevronDownIcon className="z-1 pointer-events-none absolute right-[18px] top-1/2 -translate-y-1/2 text-white" />
    </label>
  )
}

export default function TraxionRaceSearchWidget({
  games = [],
  platforms = [],
  initialGameName,
  initialPlatformName,
  forcedLayout = null,
}) {
  const [selectedGameName, setSelectedGameName] = useState(initialGameName)
  const [selectedPlatformName, setSelectedPlatformName] =
    useState(initialPlatformName)

  const gameMap = useMemo(
    () => new Map(games.map((game) => [game.name, game])),
    [games],
  )
  const platformMap = useMemo(
    () => new Map(platforms.map((platform) => [platform.name, platform])),
    [platforms],
  )

  const selectedGame = gameMap.get(selectedGameName) || null
  const headingGameLabel =
    selectedGame?.longname ||
    selectedGame?.nicename ||
    selectedGame?.abbreviation ||
    selectedGame?.name ||
    'Sim Racing'

  const availableGames = useMemo(() => {
    if (
      !selectedPlatformName ||
      selectedPlatformName === TRAXION_ANY_PLATFORM.name
    ) {
      return games
    }

    return games.filter((game) =>
      Array.isArray(game.platformNames)
        ? game.platformNames.includes(selectedPlatformName)
        : false,
    )
  }, [games, selectedPlatformName])

  const availablePlatforms = useMemo(() => {
    if (!selectedGame || !Array.isArray(selectedGame.platformNames)) {
      return platforms
    }

    return platforms.filter(
      (platform) =>
        platform.name === TRAXION_ANY_PLATFORM.name ||
        selectedGame.platformNames.includes(platform.name),
    )
  }, [platforms, selectedGame])

  const searchHref = useMemo(
    () =>
      buildTraxionEventsSearchHref({
        gameName: selectedGameName,
        platformName: selectedPlatformName,
      }),
    [selectedGameName, selectedPlatformName],
  )

  function handleGameChange(nextGameName) {
    const nextGame = gameMap.get(nextGameName)
    setSelectedGameName(nextGameName)

    if (
      nextGame &&
      selectedPlatformName !== TRAXION_ANY_PLATFORM.name &&
      Array.isArray(nextGame.platformNames) &&
      !nextGame.platformNames.includes(selectedPlatformName)
    ) {
      const nextPlatformName = nextGame.platformNames.find((platformName) =>
        platformMap.has(platformName),
      )

      if (nextPlatformName) {
        setSelectedPlatformName(nextPlatformName)
      }
    }
  }

  function handlePlatformChange(nextPlatformName) {
    setSelectedPlatformName(nextPlatformName)

    if (nextPlatformName === TRAXION_ANY_PLATFORM.name) {
      return
    }

    if (
      selectedGame &&
      Array.isArray(selectedGame.platformNames) &&
      !selectedGame.platformNames.includes(nextPlatformName)
    ) {
      const nextGame = games.find((game) =>
        Array.isArray(game.platformNames)
          ? game.platformNames.includes(nextPlatformName)
          : false,
      )

      if (nextGame) {
        setSelectedGameName(nextGame.name)
      }
    }
  }

  const showMobileLayout = forcedLayout === 'mobile'
  const showDesktopLayout = forcedLayout === 'desktop'

  return (
    <div className="w-full bg-transparent">
      <div
        className={cn(
          'flex justify-center min-[870px]:hidden',
          showMobileLayout && 'min-[870px]:flex',
          showDesktopLayout && 'hidden',
        )}
      >
        <div className="relative h-[343px] w-full max-w-[313px] overflow-hidden rounded-md bg-[#08111b]">
          <div className="absolute inset-0 rounded-md bg-[#08111b]" />
          <Image
            src="/img/traxion/widget-banner.png"
            alt=""
            fill
            priority
            aria-hidden="true"
            className="rounded-md object-cover opacity-10"
          />
          <div className="bg-linear-to-b absolute inset-0 rounded-md from-[rgba(1,8,16,0)] from-[52.083%] to-[#010810]" />

          <div className="relative z-10 flex h-full flex-col items-center px-4 pt-[26px]">
            <TraxionGridFinderLogo
              className="h-[24.273px] w-[97.165px]"
              aria-hidden="true"
            />

            <p
              className="bg-linear-to-b mt-[14px] max-w-[251px] from-[#ff6100] via-[#ff4f00] to-[#ff3d00] bg-clip-text text-center text-[20px] font-bold uppercase leading-none text-transparent"
              style={{ fontFamily: 'var(--font-syncopate), sans-serif' }}
            >
              {`Find ${headingGameLabel} Races`}
            </p>

            <div className="mt-[14px] flex h-[213px] w-full max-w-[281px] flex-col gap-2 rounded-md border border-neutral-blue-700 px-2 py-[9px]">
              <TraxionSelect
                label="Platform"
                value={selectedPlatformName}
                onValueChange={handlePlatformChange}
                options={availablePlatforms}
                getOptionLabel={getPlatformDisplayLabel}
                className="h-[63px] w-full rounded-[2.535px]"
                selectClassName="pb-[11px] pl-[20px] pr-[44px] pt-[30px]"
              />
              <TraxionSelect
                label="Game"
                value={selectedGameName}
                onValueChange={handleGameChange}
                options={availableGames}
                getOptionLabel={getGameDisplayLabel}
                className="h-[63px] w-full rounded-[2.535px]"
                selectClassName="pb-[11px] pl-[20px] pr-[44px] pt-[30px]"
              />
              <a
                href={searchHref}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-linear-to-b flex h-[53px] w-full items-center justify-center gap-[7.847px] rounded-[2.535px] border border-[#ff8940] from-[#ff6100] via-[#ff4f00] to-[#ff3d00] text-[16px] font-semibold text-white transition-opacity hover:opacity-95"
                style={{ fontFamily: 'var(--font-inter), sans-serif' }}
              >
                <TraxionSearchIcon className="shrink-0" />
                <span>Search</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div
        className={cn(
          'hidden min-[870px]:items-center min-[870px]:justify-center',
          showMobileLayout ? 'hidden' : 'min-[870px]:flex',
          showDesktopLayout && 'flex items-center justify-center',
        )}
      >
        <div className="w-full max-w-[1320px] overflow-hidden rounded-md">
          <div className="relative h-[112.941px] w-full overflow-hidden rounded-md border border-white/10 bg-[#08111b] shadow-[inset_0_0_0_1px_rgba(255,255,255,0.03)]">
            <Image
              src="/img/traxion/widget-banner.png"
              alt=""
              fill
              priority
              aria-hidden="true"
              className="object-cover"
            />

            <div className="relative z-10 flex h-full w-full items-center gap-[clamp(14px,2vw,32px)] px-[clamp(16px,3vw,40px)] py-[14px]">
              <TraxionGridFinderLogo
                className="h-auto w-[clamp(96px,12vw,127.059px)] shrink-0"
                aria-hidden="true"
              />

              <div className="min-w-0 flex-1">
                <p
                  className="bg-linear-to-b truncate from-[#ff6100] via-[#ff4f00] to-[#ff3d00] bg-clip-text text-[clamp(18px,2.2vw,24px)] font-bold uppercase leading-none text-transparent"
                  style={{ fontFamily: 'var(--font-syncopate), sans-serif' }}
                >
                  {`Find ${headingGameLabel} Races`}
                </p>
              </div>

              <div className="grid h-[85px] w-[clamp(300px,41.3%,545px)] shrink-0 grid-cols-3 gap-[clamp(8px,1.2vw,16px)] rounded-[2.616px] border border-neutral-blue-700 px-[10px]">
                <TraxionSelect
                  label="Platform"
                  value={selectedPlatformName}
                  onValueChange={handlePlatformChange}
                  options={availablePlatforms}
                  getOptionLabel={getPlatformDisplayLabel}
                  className="h-[64.941px] w-full self-center"
                />
                <TraxionSelect
                  label="Game"
                  value={selectedGameName}
                  onValueChange={handleGameChange}
                  options={availableGames}
                  getOptionLabel={getGameDisplayLabel}
                  className="h-[64.941px] w-full self-center"
                />
                <a
                  href={searchHref}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-linear-to-b flex h-[64.941px] w-full items-center justify-center gap-[7.847px] self-center rounded-[2.616px] border border-[#ff8940] from-[#ff6100] via-[#ff4f00] to-[#ff3d00] text-[16px] font-semibold text-white transition-opacity hover:opacity-95"
                  style={{ fontFamily: 'var(--font-inter), sans-serif' }}
                >
                  <TraxionSearchIcon className="shrink-0" />
                  <span>Search</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
